// Default Privacy Policy text. Admins can override this from Settings.
// Format: lines starting with "# " are section headings, lines starting with
// "- " are bullet points, blank lines separate paragraphs.
export const DEFAULT_PRIVACY = `# 1. Introduction
GOBRA Capital Real Estate ("we", "us", or "our") is committed to protecting the privacy of every visitor, client, and investor who interacts with us. This Privacy Policy explains how we collect, use, store, and safeguard your personal information when you use our website, submit an enquiry, or engage our real-estate services in Dubai and the United Arab Emirates.

By using our website or sharing your information with us, you agree to the practices described in this policy.

# 2. Information We Collect
We only collect information that helps us serve you better. This may include:
- Contact details you provide — your name, email address, phone number and country code when you submit an enquiry or contact form.
- Enquiry details — the project, area, or property you are interested in, along with any message or preferences you share.
- Communication records — notes and correspondence relating to your enquiry so our advisors can follow up accurately.
- Technical data — basic, non-identifying information such as browser type and pages visited, used only to improve the website experience.

# 3. How We Use Your Information
Your information is used strictly for legitimate business purposes, including:
- Responding to your enquiries and arranging property viewings or consultations.
- Sharing relevant project information, availability, pricing and brochures that match your interests.
- Assigning a dedicated property advisor to assist you.
- Sending occasional updates about new launches or opportunities, where you have agreed to receive them.
- Meeting our legal, regulatory and record-keeping obligations as a licensed real-estate brokerage in the UAE.

# 4. Sharing of Information
We do not sell or rent your personal information to third parties. Your details may be shared only with:
- Our internal team and licensed property advisors handling your enquiry.
- Reputable developers or partners strictly when required to progress a transaction you have requested.
- Service providers (such as our secure CRM and email systems) who process data on our behalf under confidentiality obligations.
- Government or regulatory authorities where disclosure is required by UAE law.

# 5. Data Security
We apply appropriate technical and organisational measures to protect your information against unauthorised access, loss, or misuse. Access to personal data is restricted to authorised staff on a need-to-know basis.

# 6. Data Retention
We retain your personal information only for as long as necessary to fulfil the purposes outlined in this policy, to maintain our client relationship, and to comply with legal and regulatory requirements.

# 7. Your Rights
You have the right to:
- Request access to the personal information we hold about you.
- Ask us to correct or update inaccurate information.
- Request that we delete your information, subject to our legal obligations.
- Withdraw your consent to marketing communications at any time.

# 8. Cookies
Our website uses only essential cookies required for the site to function and for you to stay securely signed in to any account area. We do not use intrusive tracking or advertising cookies.

# 9. Changes to This Policy
We may update this Privacy Policy from time to time. Any changes will be published on this page with a revised date. We encourage you to review it periodically.`;
